import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callbar',
  templateUrl: './callbar.component.html',
  styleUrls: ['./callbar.component.scss'],
  standalone: false
})
export class CallbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
